
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 605.942 605.942"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M435.099 0c-45.632 0-88.544 17.777-120.822 50.055L50.036 314.276c-66.603 66.622-66.603 175.018 0 241.64 32.269 32.259 75.171 50.026 120.808 50.026s88.544-17.768 120.812-50.026l19.757-19.751-12.321.588c-.062.005-.728.033-1.889.033-5.709 0-25.776-.746-44.309-10.312l-2.815-1.454-2.43 2.027c-21.425 17.915-48.706 27.779-76.806 27.779-32.034 0-62.118-12.432-84.714-35.009-22.592-22.591-35.037-52.68-35.037-84.724s12.445-62.127 35.037-84.724L350.37 86.149c22.592-22.591 52.685-35.037 84.729-35.037 32.04 0 62.128 12.446 84.724 35.037 46.666 46.703 46.666 122.696.005 169.399L354.798 420.19c-8.291 8.306-19.771 12.881-32.331 12.881-13.641 0-26.847-5.394-36.242-14.808-9.018-9.008-14.181-21.563-14.176-34.463 0-12.604 4.776-24.304 13.431-32.938L432.541 204.36l-36.099-36.094L249.366 314.75c-18.479 18.479-28.539 43.284-28.334 69.84.206 26.444 10.538 51.222 29.09 69.772 18.871 18.867 45.226 29.687 72.321 29.687 26.244 0 50.566-9.863 68.486-27.765l164.986-164.628c66.589-66.631 66.589-175.018 0-241.601C523.643 17.777 480.731 0 435.099 0z"}})])
          )
        }
      }
    